import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ConfirmProvider } from "@/hooks/useConfirm";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import Login2FAPage from "@/pages/Login2FAPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import DemoLoginPage from "@/pages/DemoLoginPage";
import HomePage from "@/pages/HomePage";
import DocumentsPage from "@/pages/DocumentsPage";
import DocumentViewerPage from "@/pages/DocumentViewerPage";
import SettingsPage from "@/pages/SettingsPage";
import FundsPage from "@/pages/FundsPage";
import PlanPage from "@/pages/PlanPage";
import LedgerDashboardPage from "@/pages/LedgerDashboardPage";
import LedgerInspectionPage from "@/pages/LedgerInspectionPage";
import PharosPage from "@/pages/PharosPage";
import "@/App.css";

export default function App() {
  return (
    <ConfirmProvider>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify" element={<VerifyEmailPage />} />
        <Route path="/login/verify-2fa" element={<Login2FAPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/demo" element={<DemoLoginPage />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          {/* Full-page viewer: outside AppLayout */}
          <Route path="/documents/view/*" element={<DocumentViewerPage />} />
          <Route element={<AppLayout />}>
            <Route path="/home" element={<HomePage />} />
            <Route path="/dashboard" element={<LedgerDashboardPage />} />
            <Route path="/ledger" element={<Navigate to="/dashboard" replace />} />
            <Route path="/ledger-inspection" element={<LedgerInspectionPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/groups" element={<FundsPage />} />
            <Route path="/plan" element={<PlanPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            {/* Direct-URL only — no Sidebar entry until >10 clients (founder decision). */}
            <Route path="/pharos" element={<PharosPage />} />
          </Route>
        </Route>

        {/* Catch-all redirect — this is the REAL post-login landing mechanism:
            LoginPage/Login2FAPage navigate("/catalog"), a dead route, which falls
            through here. /home is the intended landing surface for real tenants. */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </ConfirmProvider>
  );
}
